import { formatAmount } from "./formatData.js";

export default async function intentCopywriting(intent, data, content) {

    const response = await fetch("../../public/intent.json");
    const responseData = await response.json();
    let formattedMessage;

    if (intent === "available_balance_retail_principal") {
        if (data.combinedAvailableLimit <= 0) {
            formattedMessage = responseData.available_balance_retail_principal_available_negative;
        } else if (data.combinedCreditLimit >= data.combinedAvailableLimit) {
            formattedMessage = responseData.available_balance_retail_principal_credit_gt_available;
        } else {
            formattedMessage = responseData.available_balance_retail_principal_available_gt_credit;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${combinedCreditLimit}", formatAmount(data.combinedCreditLimit));
        formattedMessage = formattedMessage.replace("${combinedAvailableLimit}", formatAmount(data.combinedAvailableLimit));
        return formattedMessage;
    } else if (intent === "available_balance_cash_principal") {
        formattedMessage = responseData.available_balance_cash_principal;
        formattedMessage = formattedMessage.replace("${combinedCreditLimit}", formatAmount(data.combinedCreditLimit));
        formattedMessage = formattedMessage.replace("${combinedAvailableLimit}", formatAmount(data.combinedAvailableLimit));
        return formattedMessage;
    } else if (intent === "eligible_amount_fpp") {
        if (data.fppEligibleAmount < 500) {
            formattedMessage = responseData.eligible_amount_fpp_lt_500;
        } else {
            formattedMessage = responseData.eligible_amount_fpp_gte_500;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${fppEligibleAmount}", formatAmount(data.fppEligibleAmount));
        return formattedMessage;
    } else if (intent === "eligible_amount_balance_transfer") {
        if (data.btEligibleAmount < 1000) {
            formattedMessage = responseData.eligible_amount_balance_transfer_lt_1000;
        } else {
            formattedMessage = responseData.eligible_amount_balance_transfer_gte_1000;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${btEligibleAmount}", formatAmount(data.btEligibleAmount));
        return formattedMessage;
    } else if (intent === "eligible_amount_quick_cash") {
        if (data.cfcEligibleAmount < 500) {
            formattedMessage = responseData.eligible_amount_quick_cash_lt_500;
        } else {
            formattedMessage = responseData.eligible_amount_quick_cash_gte_500;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${cfcEligibleAmount}", formatAmount(data.cfcEligibleAmount));
        return formattedMessage;
    } else if (intent === "last_payment") {
        if (data.lastPaymentDate === "") {
            formattedMessage = responseData.last_payment.no_last_payment;
        } else {
            formattedMessage = responseData.last_payment.has_last_payment;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${lastPaymentAmount}", formatAmount(data.lastPaymentAmount));
        formattedMessage = formattedMessage.replace("${lastPaymentDate}", data.lastPaymentDate);
        formattedMessage = formattedMessage.replace("${statementDate}", data.statementDate);
        return formattedMessage;
    } else if (intent === "outstanding_balance") {
        formattedMessage = responseData.outstanding_balance;
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${outstandingBalance}", formatAmount(data.outstandingBalance));
        formattedMessage = formattedMessage.replace("${statementDate}", data.statementDate);
        formattedMessage = formattedMessage.replace("${paymentDueDate}", data.paymentDueDate);
        formattedMessage = formattedMessage.replace("${statementBalance}", formatAmount(data.statementBalance));
        formattedMessage = formattedMessage.replace("${minimumPaymentAmount}", formatAmount(data.minimumPaymentAmount));
        formattedMessage = formattedMessage.replace("${pastDueAmount}", formatAmount(data.pastDueAmount));
        formattedMessage = formattedMessage.replace("${totalDueAmount}", formatAmount(data.totalDueAmount));
        return formattedMessage;
    } else if (intent === "cardholder_payoff_inquiry") {
        formattedMessage = responseData.cardholder_payoff_inquiry;
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${payOffAmount}", formatAmount(data.payOffAmount));
        return formattedMessage;
    } else if (intent === "last_transaction") {
        if (data.recentTransactionList.length === 0) {
            formattedMessage = responseData.last_transaction.no_last_transaction;
        } else {
            formattedMessage = responseData.last_transaction.has_last_transaction.transaction_summary;
            data.recentTransactionList.forEach((transaction, index) => {
                formattedMessage += responseData.last_transaction.has_last_transaction.transaction_details
                    .replace("${index}", index + 1)
                    .replace("${transactionDate}", transaction.transactionDate)
                    .replace("${merchantDescription}", transaction.merchantDescription)
                    .replace("${transactionAmount}", formatAmount(transaction.transactionAmount))
            });
            formattedMessage += responseData.last_transaction.has_last_transaction.transaction_ending;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        return formattedMessage;
    } else if (intent === "unstatement_transaction") {
        if (data.cardHistoryLists.length === 0) {
            formattedMessage = responseData.unstatement_transaction.no_unstatement_transaction;
        } else {
            formattedMessage = responseData.unstatement_transaction.has_unstatement_transaction.transaction_summary;
            data.cardHistoryLists.forEach((item, index) => {
                formattedMessage += responseData.unstatement_transaction.has_unstatement_transaction.transaction_details
                    .replace("${index}", index + 1)
                    .replace("${transactionDate}", item.transactionDate)
                    .replace("${transactionDescription}", item.transactionDescription)
                    .replace("${amount}", formatAmount(item.debitAmount !== null ? item.debitAmount : -item.creditAmount))
                    .replace("${postingDate}", item.postingDate);
            });
            formattedMessage += responseData.unstatement_transaction.has_unstatement_transaction.transaction_ending;
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        formattedMessage = formattedMessage.replace("${outstandingBalance}", data.outstandingBalance);
        formattedMessage = formattedMessage.replace("${statementDate}", data.statementDate);
        return formattedMessage;
    } else if (intent === "retail_cash_interest") {
        if (data.cardHistoryLists.length === 0) {
            formattedMessage = responseData.retail_cash_interest.no_retail_cash_interest;
        } else {
            formattedMessage = responseData.retail_cash_interest.has_retail_cash_interest;
            formattedMessage = formattedMessage.replace("${statementDate}", data.cardHistoryLists[0].statementDate);
            formattedMessage = formattedMessage.replace("${retailInterest}", formatAmount(data.cardHistoryLists[0].retailInterest));
            formattedMessage = formattedMessage.replace("${cashInterest}", formatAmount(data.cardHistoryLists[0].cashInterest));
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        return formattedMessage;
    } else if (intent === "retail_interest") {
        if (data.cardHistoryLists.length === 0) {
            formattedMessage = responseData.retail_interest.no_retail_interest;
        } else {
            formattedMessage = responseData.retail_interest.has_retail_interest;
            formattedMessage = formattedMessage.replace("${statementDate}", data.cardHistoryLists[0].statementDate);
            formattedMessage = formattedMessage.replace("${retailInterest}", formatAmount(data.cardHistoryLists[0].retailInterest));
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        return formattedMessage;
    } else if (intent === "cash_interest") {
        if (data.cardHistoryLists.length === 0) {
            formattedMessage = responseData.cash_interest.no_cash_interest;
        } else {
            formattedMessage = responseData.cash_interest.has_cash_interest;
            formattedMessage = formattedMessage.replace("${statementDate}", data.cardHistoryLists[0].statementDate);
            formattedMessage = formattedMessage.replace("${cashInterest}", formatAmount(data.cardHistoryLists[0].cashInterest));
        }
        formattedMessage = formattedMessage.replace("${productName}", content.productName);
        formattedMessage = formattedMessage.replace("${accountNumberLast4}", content.accountNumber.substring(content.accountNumber.length - 4, content.accountNumber.length));
        return formattedMessage;
    } else if (intent === "status" && data.isActive) {
        formattedMessage = responseData.status.active;
        return formattedMessage;
    } else if (intent === "status" && !data.isActive) {
        formattedMessage = responseData.status.non_active;
        return formattedMessage;
    } else if (intent === "blocked_date") {
        if (data.dateBlocked === "00000000") {
            formattedMessage = responseData.blocked_date.no_blocked_date;
        } else {
            // const year = data.dateBlocked.slice(0, 4);
            // const month = data.dateBlocked.slice(4, 6) - 1;
            // const day = data.dateBlocked.slice(6, 8);
            // const date = new Date(year, month, day);
            // const formattedDate = date.toLocaleDateString("en-GB");
            formattedMessage = responseData.blocked_date.has_blocked_date;
            // formattedMessage = formattedMessage.replace("${formattedDate}", formattedDate);
        }
        return formattedMessage;
    } else {
        return formattedMessage.intent_not_found
    }

}
